require('./cardRewardsSideBar.scss');

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
//@core
const { getLanguage } = require('core/i18n').i18n;
//@ helpers
const {
    formatAmountObject,
    formatPercentage,
    getPlainAmountObject,
} = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { formatText } = require('core/i18n').i18n;
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
//@constants
const { NO_PRIME, PRIME } = require('constants/nerudaCard');

class CardRewardsSideBar extends React.Component {
    render() {
        const { immCardRewards } = this.props;
        const plainAmountObject = getPlainAmountObject(immCardRewards.get('totalAmount'));
        const language = getLanguage();
        const paymentAccount = immCardRewards.getIn(['paymentAccount', 'bank'], '-')+getLastNChars(immCardRewards.getIn(['paymentAccount', 'number'],''));
        const bonificationStatus = immCardRewards.getIn(['bonification', 'status']);
        let content = <LoadingSection />;
        let amount = '-';
        let bonification = '-';
        let bonificationText = '';

        if (bonificationStatus === PRIME) {
            bonificationText = formatText('cardRewardsSidebar-cardRewardsSidebar_primeText');
        } else if (bonificationStatus === NO_PRIME) {
            bonificationText = formatText('cardRewardsSidebar-cardRewardsSidebar_noPrimeText');
        }

        if (!immCardRewards.get('loading')) {
            if (!immCardRewards.get('error')) {
                bonification = `${bonificationText} ${formatPercentage(immCardRewards.getIn(['bonification','level']))}`;
                amount = (
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        language={language}
                        positiveAmount={true}
                    />
                );
            }

            content = (
                <OKInformativeList>
                    <OKInformativeListItem key="totalAmount" title="cardRewardsSidebar-cardRewardsSidebar_totalAmount">
                        <span className="card-rewards-side-bar__field--big">
                            {amount}
                        </span>
                    </OKInformativeListItem>
                    <OKInformativeListItem key="paymentLevel" title="cardRewardsSidebar-cardRewardsSidebar_bonificationLevel">
                        <span className="card-rewards-side-bar__field">
                            {bonification}
                        </span>
                    </OKInformativeListItem>
                    <OKInformativeListItem key="paymentAccount" title="cardRewardsSidebar-cardRewardsSidebar_paymentAccount">
                        <span className="card-rewards-side-bar__field">
                            {paymentAccount}
                        </span>
                    </OKInformativeListItem>
                </OKInformativeList>
            );
        }

        return (
            <OKSectionBox>
                {content}
            </OKSectionBox>
        );
    }
}

CardRewardsSideBar.propTypes = {
    immCardRewards: PropTypes.object.isRequired
};

module.exports = CardRewardsSideBar;